// src/lib/redux/scoutCounts/scoutCountsSlice.ts
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface ScoutCountSeries {
  media_id: number;
  data: number[];
}

interface ScoutCountsState {
  labels: string[];
  series: ScoutCountSeries[];
  loading: boolean;
  error: string | null;
}

const initialState: ScoutCountsState = {
  labels: [],
  series: [],
  loading: false,
  error: null,
};

const scoutCountsSlice = createSlice({
  name: "scoutCounts",
  initialState,
  reducers: {
    fetchScoutCountsStart(state) {
      state.loading = true;
      state.error = null;
    },
    fetchScoutCountsSuccess(
      state,
      action: PayloadAction<{
        labels: string[];
        series: ScoutCountSeries[];
      }>,
    ) {
      state.labels = action.payload.labels;
      state.series = action.payload.series;
      state.loading = false;
      state.error = null;
    },
    fetchScoutCountsFailure(state, action: PayloadAction<string>) {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const {
  fetchScoutCountsStart,
  fetchScoutCountsSuccess,
  fetchScoutCountsFailure,
} = scoutCountsSlice.actions;

export default scoutCountsSlice.reducer;
